import Phaser from 'phaser';
import Background, {
  preload as preloadBackground,
} from '../../objects/test/Background';
import Player, { preload as preloadPlayer } from '../../objects/test/Player';

export default class ControlledPlayer extends Phaser.Scene {
  constructor() {
    super({ key: 'ControlledPlayer', active: true });
  }

  preload() {
    this.load.setBaseURL('/assets/test/');

    preloadBackground.call(this, 'background_flat', '1.png');
    preloadBackground.call(this, 'background_trees', '3.png');
    preloadBackground.call(this, 'background_spiders', '4.png');
    preloadBackground.call(this, 'background_ground', 'ground.png');

    preloadPlayer.call(this);
  }

  create() {
    // BACKGROUND
    this.background_flat = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_flat',
    });
    this.background_trees = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_trees',
    });
    this.background_spiders = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_spiders',
    });
    this.background_ground = new Background({
      scene: this,
      x: 0,
      y: this.game.config.height,
      width: 0, // If zero it will use the size of the texture frame.
      height: 0, // If zero it will use the size of the texture frame.
      key: 'background_ground',
    });

    this.physics.add.existing(this.background_ground);
    this.background_ground.body.setSize(this.game.config.width * 5, 100);
    this.background_ground.body.setAllowGravity(false);
    this.background_ground.body.immovable = true;

    // PLAYER
    this.player = new Player({
      scene: this,
      x: 200,
      y: this.game.config.height - 60,
    });
    this.player.setOrigin(0.5, 1);
    this.player.body.setCollideWorldBounds(true);

    // PHYSICS
    this.physics.world.setBounds(
      0,
      0,
      this.game.config.width * 3,
      this.game.config.height
    );
    this.physics.world.setBoundsCollision(true);
    this.physics.add.collider(this.player, this.background_ground);
    
    // CAMERA
    this.cameras.main.setBounds(
      0,
      0,
      this.game.config.width * 3,
      this.game.config.height
    );
    this.cameras.main.startFollow(this.player, true, 0.05, 0.05);

    // CONTROLS
    this.cursor = this.input.keyboard.createCursorKeys();
  }

  update(time, delta) {
    if (this.cursor.right.isDown) {
      this.player.body.setVelocityX(300);
      this.player.flipX = false;
    } else if (this.cursor.left.isDown) {
      this.player.body.setVelocityX(-300);
      this.player.flipX = true;
    } else {
      this.player.body.setVelocity(0);
    }

    this.background_trees.tilePositionX = this.cameras.main.scrollX * 0.4;
    this.background_spiders.tilePositionX = this.cameras.main.scrollX * 0.7;
    this.background_ground.tilePositionX = this.cameras.main.scrollX * 1;
  }
}
